"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const generate = (node) => {
    switch (node.type) {
        case 'Program':
            return node.body.map(exports.generate).join('');
        case 'BlockStatement': {
            let lastNode = undefined;
            const lastElement = node.body[node.body.length - 1];
            if (lastElement &&
                lastElement.type === 'ExpressionStatement' &&
                lastElement.expression.type !== 'AssignmentExpression') {
                lastNode = node.body.pop();
            }
            return `{${node.body.map(exports.generate).join('')}${lastNode ? ` return ${exports.generate(lastNode)}` : ''}}`;
        }
        case 'IfStatement':
            return `if (${exports.generate(node.test)}) ${exports.generate(node.consequent)} ${node.alternate
                ? `else ${exports.generate(node.alternate)}`
                : ''}`;
        case 'VariableDeclaration':
            return `${node.kind} ${node.declarations
                .map(exports.generate)
                .join('')};`;
        case 'VariableDeclarator':
            return `${exports.generate(node.id)} = ${exports.generate(node.init)}`;
        case 'Identifier':
            return `${node.name
                .split('-')
                .map((e, i) => (i === 0 ? e : `${e[0].toUpperCase()}${e.slice(1)}`))
                .join('')}`;
        case 'ExpressionStatement':
            return `${exports.generate(node.expression)};`;
        case 'AssignmentExpression':
            return `${exports.generate(node.left)} ${node.operator} ${exports.generate(node.right)}`;
        case 'CallExpression': {
            if (node.callee.type === 'ArrowFunctionExpression') {
                return `(${exports.generate(node.callee)})(${node.arguments
                    .map(exports.generate)
                    .join(', ')})`;
            }
            else {
                return `${exports.generate(node.callee)}(${node.arguments
                    .map(exports.generate)
                    .join(', ')})`;
            }
        }
        case 'ArrayExpression':
            return `[${node.elements.map(exports.generate).join(', ')}]`;
        case 'ArrowFunctionExpression': {
            if (node.body.type !== 'BlockStatement') {
                return `(${node.params
                    .map(exports.generate)
                    .join(', ')}) => (${exports.generate(node.body)})`;
            }
            else {
                return `(${node.params
                    .map(exports.generate)
                    .join(', ')}) => ${exports.generate(node.body)}`;
            }
        }
        case 'MemberExpression': {
            if (!node.computed) {
                return `${exports.generate(node.object)}.${exports.generate(node.property)}`;
            }
            else {
                return `${exports.generate(node.object)}[${exports.generate(node.property)}]`;
            }
        }
        case 'ObjectExpression':
            return `{${node.properties.map(exports.generate).join(', ')}}`;
        case 'Property':
            return `${exports.generate(node.key)}: ${exports.generate(node.value)}`;
        case 'BinaryExpression':
            return `(${exports.generate(node.left)} ${node.operator} ${exports.generate(node.right)})`;
        case 'UnaryExpression':
            return `${node.operator}${exports.generate(node.argument)}`;
        case 'SpreadElement':
            return `...${exports.generate(node.argument)}`;
        case 'Literal':
            return `${node.value}`;
        default:
            throw new Error(`Undefined AST node: ${node.type}`);
    }
};
exports.generate = generate;
